var React = require('react');

function ArrowFromBottom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M360 480H24a23.94 23.94 0 0 1-24-24v-16a23.94 23.94 0 0 1 24-24h336a23.94 23.94 0 0 1 24 24v16a23.94 23.94 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M56.13 225.48l-17.06-17a23.86 23.86 0 0 1 0-33.91L175 39.05a24 24 0 0 1 34 0l135.93 135.52a23.86 23.86 0 0 1 0 33.91l-17.06 17a24 24 0 0 1-34 0l-65.81-65.61V360A24 24 0 0 1 204 384h-24.09a24 24 0 0 1-24.07-24V159.87L90 225.48a23.9 23.9 0 0 1-33.87 0z","className":"fa-primary","key":2})]);
}

ArrowFromBottom.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowFromBottom;

ArrowFromBottom.default = ArrowFromBottom;
